// ======================================================================
// File Name       : ChatBubbles
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Button, Col, Row } from 'react-bootstrap';
import $ from 'jquery';
import { MAX_MESSAGE_NUM, MESSAGE_TYPE, DELETE_MSG } from '../../constants/MessageThreadContants';
import { parseDateForDetail } from '../../utils/index';
import { SUPER_USER_SECERN_ID } from '../../constants/index';
import { checkAuthorSuperuser } from '../../utils/PageUtils';

let totalRecord = 0;
let length = 0;

class ChatBubbles extends React.Component {
  constructor(props) {
    super(props);
    this.drawChatBubbles = this.drawChatBubbles.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    const shouldNotUpdate = nextProps.structureList.length === this.props.structureList.length
      && nextProps.reloadChat === this.props.reloadChat;
    if (shouldNotUpdate) {
      return false;
    }
    return true;
  }

  componentDidUpdate(prevProps) {
    const { isLoadMore, isDelete, loadMoreFinish, pageNum } = this.props;
    if (isLoadMore) {
      const totalHeight = getLoadMoreHeight(pageNum);
      $('#chat-container').scrollTop(totalHeight);
    } else if (!isLoadMore && !isDelete) {
      $('#chat-container').scrollTop($('#chat-container .table-no-border').height());
    }
  }

  componentDidMount() {
    const { loadMore } = this.props;
    $('#chat-container').scroll(() => {
      if ($('#chat-container').scrollTop() === 0 && length < totalRecord) {
        loadMore();
      }
    });
  }

  drawChatBubbles(structureList, mySecernId, downloadAttachment, deleteMyMessage, superUser, representationUserSecernId) {
    let body = null;
    if (structureList && structureList.length) {
      body = structureList.map((messageInfo, index) => {
        const {
          messageContent,
          authorSecernId,
          authorName,
          createdAt,
          attachmentFileName,
          messageDeletedFlag,
          messageType,
        } = messageInfo;
        const showDeleteIcon = !messageDeletedFlag && messageType !== MESSAGE_TYPE.ROUTE;
        const showDownloadIcon = !messageDeletedFlag && attachmentFileName;
        const contentMessage = messageDeletedFlag ? DELETE_MSG : messageContent;
        if (messageType === MESSAGE_TYPE.ROUTE) {
          return null;
        }
        // Step10.0.0 START
        if (mySecernId === authorSecernId
          || checkAuthorSuperuser(authorSecernId, superUser, representationUserSecernId)
        ) {
        // Step10.0.0 END
          return (
            <div key={index}>
              <Col sm={12} className="margin-top-10 d-flex justify-content-end">
                <Col sm={2} />
                <Col sm={2} />
                <Col sm={6}>
                  <div className="talk-bubble talk-bubble-right tri-right round right-top">
                    <div className="breakDot">{contentMessage}</div>
                    <div className="text-right padding-top-10">
                      {showDeleteIcon && (
                        <i
                          role="button"
                          className="bi bi-x-lg"
                          onClick={() => {
                            deleteMyMessage(messageInfo, representationUserSecernId);
                          }}
                        />
                      )}{' '}
                      {showDownloadIcon && (
                        <i
                          role="button"
                          className="bi bi-file-earmark-fill"
                          onClick={() => {
                            downloadAttachment(messageInfo);
                          }}
                        />
                      )}
                    </div>
                  </div>
                  <div style={{ textAlign: 'left', marginRight: '20px', marginTop: '5px' }}>{parseDateForDetail(createdAt)}</div>
                </Col>
                <Col sm={2}>
                  <div>{authorName}</div>
                </Col>
              </Col>
            </div>
          );
        }
        return (
          <div key={index}>
            <Col sm={12} className="margin-top-10">
              <Row>
                <Col sm={2}>
                  <div>{authorName}</div>
                </Col>
                <Col sm={6}>
                  <div className="talk-bubble talk-bubble-left tri-right round left-top">
                    <div className="breakDot">{contentMessage}</div>

                    {showDownloadIcon && (
                      <div className="text-right padding-top-10">
                        <i
                          role="button"
                          className="bi bi-file-earmark-fill"
                          onClick={() => {
                            downloadAttachment(messageInfo);
                          }}
                        />
                      </div>
                    )}
                  </div>
                  <div style={{ textAlign: 'left', marginTop: '5px' }}>
                    {parseDateForDetail(createdAt)}
                  </div>
                </Col>
                <Col sm={2} />
                <Col sm={2} />
              </Row>
            </Col>
          </div>
        );
      });
    }
    return body;
  }

  render() {
    const {
      structureList,
      mySecernId,
      downloadAttachment,
      deleteMyMessage,
      superUser,
      representationUserSecernId,
    } = this.props;
    totalRecord = this.props.filteredStructureRecordNum;
    length = structureList.length;
    const tbody = this.drawChatBubbles(
      structureList,
      mySecernId,
      downloadAttachment,
      deleteMyMessage,
      superUser,
      representationUserSecernId,
    );
    return (
      <div className="col-sm-12" id="chat-container" style={{ height: '35vh', overflowY: 'auto' }}>
          <Table className="margin-top-10 table-no-border">
            <tbody>
              <tr>
                <td>{tbody}</td>
              </tr>
            </tbody>
          </Table>
      </div>
    );
  }
}

function getLoadMoreHeight(pageNum) {
  let totalHeight = 0;
  if (length < 1) return 0;
  const scrollLength = length - (pageNum * MAX_MESSAGE_NUM);
  let i = 0;
  for (i; i < scrollLength; i++) {
    const child = $(`#chat-container > table > tbody > tr > td > div:eq(${i}) > div`);
    if (child && child.length) {
      totalHeight += $(child).outerHeight();
    } else {
      break;
    }
  }
  return totalHeight;
}

export default ChatBubbles;
